import classNames from 'classnames';

const CarbConsciousIcon = ({ className = '', hcSelected = false, tempoSelected = false }) => {
  if (hcSelected) {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classNames('', className)}
        role="presentation"
        pointerEvents="none"
      >
        <title>Carb Conscious</title>
        <path
          d="M17.5 6.52699V6.5H23C25.5 6.5 27.5 8.5 27.5 11C27.5 12.7449 27.0129 14.0026 26.7186 14.6032C26.5883 14.8691 26.5 15.158 26.5 15.4542V16H20.5V15.6056C20.5 15.2107 20.6187 14.8251 20.7836 14.4662C21.0792 13.8226 21.5 12.6217 21.5 11C21.5 8.66911 19.7614 6.77286 17.5 6.52699Z"
          className="fill-green-70"
        />
        <path
          d="M9 7C6.77614 7 5 8.77614 5 11C5 12.5343 5.39809 13.6639 5.6708 14.2575C5.85236 14.6528 6 15.1124 6 15.6056V17.0625C6 17.3386 5.77614 17.5625 5.5 17.5625C5.22386 17.5625 5 17.3386 5 17.0625L5 16.5H4C3.72386 16.5 3.5 16.2761 3.5 16C3.5 15.7239 3.72386 15.5 4 15.5H4.9963C4.978 15.2353 4.89269 14.9593 4.76208 14.675C4.44347 13.9813 4 12.709 4 11C4 8.22386 6.22386 6 9 6C10.6371 6 11.4959 6.4087 12.134 6.71534C12.5333 6.90716 12.7445 7 13 7C13.2555 7 13.4667 6.90716 13.866 6.71534C14.5041 6.4087 15.3629 6 17 6C17.3453 6 17.6821 6.03441 18.0071 6.1H23C25.7209 6.1 27.9 8.27909 27.9 11C27.9 12.6916 27.4611 13.9496 27.147 14.6332C27.0109 14.9296 26.9199 15.2234 26.9029 15.5094C26.9343 15.5032 26.9668 15.5 27 15.5H28C28.2761 15.5 28.5 15.7239 28.5 16C28.5 16.2761 28.2761 16.5 28 16.5H27V17.0625C27 17.3386 26.7761 17.5625 26.5 17.5625C26.2239 17.5625 26 17.3386 26 17.0625V16C26 15.8874 26.0372 15.7835 26.1 15.7V15.6056C26.1 15.1321 26.2419 14.6873 26.4201 14.2993C26.6974 13.6956 27.1 12.5518 27.1 11C27.1 8.72091 25.2791 6.9 23 6.9H19.8748C21.1629 7.80143 22 9.29677 22 11C22 12.709 21.5565 13.9813 21.2379 14.675C21.1073 14.9593 21.022 15.2353 21.0037 15.5C21.2781 15.502 21.5 15.7251 21.5 16C21.5 16.2761 21.2761 16.5 21 16.5V17.0625C21 17.3386 20.7761 17.5625 20.5 17.5625C20.2239 17.5625 20 17.3386 20 17.0625V16.5L19 16.5C18.7239 16.5 18.5 16.2761 18.5 16C18.5 15.7239 18.7239 15.5 19 15.5L20.0022 15.5C20.0213 15.0468 20.1607 14.6245 20.3292 14.2575C20.6019 13.6639 21 12.5343 21 11C21 8.77614 19.2239 7 17 7C15.5824 7 14.8792 7.3379 14.3089 7.61196L14.2634 7.63382C13.906 7.80583 13.5026 8 13 8C12.4974 8 12.094 7.80582 11.7366 7.63382L11.6911 7.61196C11.1208 7.3379 10.4176 7 9 7Z"
          className="fill-green-130"
        />
        <path
          d="M6.5 16C6.5 15.7239 6.72386 15.5 7 15.5H9C9.27614 15.5 9.5 15.7239 9.5 16C9.5 16.2761 9.27614 16.5 9 16.5H7C6.72386 16.5 6.5 16.2761 6.5 16Z"
          className="fill-green-130"
        />
        <path
          d="M11 15.5C10.7239 15.5 10.5 15.7239 10.5 16C10.5 16.2761 10.7239 16.5 11 16.5H13C13.2761 16.5 13.5 16.2761 13.5 16C13.5 15.7239 13.2761 15.5 13 15.5H11Z"
          className="fill-green-130"
        />
        <path
          d="M14.5 16C14.5 15.7239 14.7239 15.5 15 15.5H17C17.2761 15.5 17.5 15.7239 17.5 16C17.5 16.2761 17.2761 16.5 17 16.5H15C14.7239 16.5 14.5 16.2761 14.5 16Z"
          className="fill-green-130"
        />
        <path
          d="M23 15.5C22.7239 15.5 22.5 15.7239 22.5 16C22.5 16.2761 22.7239 16.5 23 16.5H25C25.2761 16.5 25.5 16.2761 25.5 16C25.5 15.7239 25.2761 15.5 25 15.5H23Z"
          className="fill-green-130"
        />
        <path
          d="M5.5 18.6875C5.77614 18.6875 6 18.9114 6 19.1875V21.3125C6 21.5886 5.77614 21.8125 5.5 21.8125C5.22386 21.8125 5 21.5886 5 21.3125V19.1875C5 18.9114 5.22386 18.6875 5.5 18.6875Z"
          className="fill-green-130"
        />
        <path
          d="M21 19.1875C21 18.9114 20.7761 18.6875 20.5 18.6875C20.2239 18.6875 20 18.9114 20 19.1875V21.3125C20 21.5886 20.2239 21.8125 20.5 21.8125C20.7761 21.8125 21 21.5886 21 21.3125V19.1875Z"
          className="fill-green-130"
        />
        <path
          d="M5.5 22.9375C5.77614 22.9375 6 23.1614 6 23.4375V24.5C6 24.7761 6.22386 25 6.5 25H7.58333C7.85948 25 8.08333 25.2239 8.08333 25.5C8.08333 25.7761 7.85948 26 7.58333 26H6.5C5.67157 26 5 25.3284 5 24.5V23.4375C5 23.1614 5.22386 22.9375 5.5 22.9375Z"
          className="fill-green-130"
        />
        <path
          d="M21 23.4375C21 23.1614 20.7761 22.9375 20.5 22.9375C20.2239 22.9375 20 23.1614 20 23.4375V24.5C20 24.7761 19.7761 25 19.5 25H18.4167C18.1405 25 17.9167 25.2239 17.9167 25.5C17.9167 25.7761 18.1405 26 18.4167 26H21.875C22.1511 26 22.375 25.7761 22.375 25.5C22.375 25.2239 22.1511 25 21.875 25H20.9146C20.9699 24.8436 21 24.6753 21 24.5V23.4375Z"
          className="fill-green-130"
        />
        <path
          d="M9.25 25.5C9.25 25.2239 9.47386 25 9.75 25H11.9167C12.1928 25 12.4167 25.2239 12.4167 25.5C12.4167 25.7761 12.1928 26 11.9167 26H9.75C9.47386 26 9.25 25.7761 9.25 25.5Z"
          className="fill-green-130"
        />
        <path
          d="M14.0833 25C13.8072 25 13.5833 25.2239 13.5833 25.5C13.5833 25.7761 13.8072 26 14.0833 26H16.25C16.5261 26 16.75 25.7761 16.75 25.5C16.75 25.2239 16.5261 25 16.25 25H14.0833Z"
          className="fill-green-130"
        />
        <path
          d="M27 19.1875C27 18.9114 26.7761 18.6875 26.5 18.6875C26.2239 18.6875 26 18.9114 26 19.1875V21.3125C26 21.5886 26.2239 21.8125 26.5 21.8125C26.7761 21.8125 27 21.5886 27 21.3125V19.1875Z"
          className="fill-green-130"
        />
        <path
          d="M26.5 22.9375C26.7761 22.9375 27 23.1614 27 23.4375V24.5C27 25.3284 26.3284 26 25.5 26H24.2917C24.0155 26 23.7917 25.7761 23.7917 25.5C23.7917 25.2239 24.0155 25 24.2917 25H25.5C25.7761 25 26 24.7761 26 24.5V23.4375C26 23.1614 26.2239 22.9375 26.5 22.9375Z"
          className="fill-green-130"
        />
      </svg>
    );
  } else if (tempoSelected) {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classNames('', className)}
        role="presentation"
        pointerEvents="none"
      >
        <title>Carb Conscious</title>
        <path
          d="M17.5 6.52699V6.5H23C25.5 6.5 27.5 8.5 27.5 11C27.5 12.7449 27.0129 14.0026 26.7186 14.6032C26.5883 14.8691 26.5 15.158 26.5 15.4542V16H20.5V15.6056C20.5 15.2107 20.6187 14.8251 20.7836 14.4662C21.0792 13.8226 21.5 12.6217 21.5 11C21.5 8.66911 19.7614 6.77286 17.5 6.52699Z"
          className="fill-tempo-blue-70"
        />
        <path
          d="M9 7C6.77614 7 5 8.77614 5 11C5 12.5343 5.39809 13.6639 5.6708 14.2575C5.85236 14.6528 6 15.1124 6 15.6056V17.0625C6 17.3386 5.77614 17.5625 5.5 17.5625C5.22386 17.5625 5 17.3386 5 17.0625L5 16.5H4C3.72386 16.5 3.5 16.2761 3.5 16C3.5 15.7239 3.72386 15.5 4 15.5H4.9963C4.978 15.2353 4.89269 14.9593 4.76208 14.675C4.44347 13.9813 4 12.709 4 11C4 8.22386 6.22386 6 9 6C10.6371 6 11.4959 6.4087 12.134 6.71534C12.5333 6.90716 12.7445 7 13 7C13.2555 7 13.4667 6.90716 13.866 6.71534C14.5041 6.4087 15.3629 6 17 6C17.3453 6 17.6821 6.03441 18.0071 6.1H23C25.7209 6.1 27.9 8.27909 27.9 11C27.9 12.6916 27.4611 13.9496 27.147 14.6332C27.0109 14.9296 26.9199 15.2234 26.9029 15.5094C26.9343 15.5032 26.9668 15.5 27 15.5H28C28.2761 15.5 28.5 15.7239 28.5 16C28.5 16.2761 28.2761 16.5 28 16.5H27V17.0625C27 17.3386 26.7761 17.5625 26.5 17.5625C26.2239 17.5625 26 17.3386 26 17.0625V16C26 15.8874 26.0372 15.7835 26.1 15.7V15.6056C26.1 15.1321 26.2419 14.6873 26.4201 14.2993C26.6974 13.6956 27.1 12.5518 27.1 11C27.1 8.72091 25.2791 6.9 23 6.9H19.8748C21.1629 7.80143 22 9.29677 22 11C22 12.709 21.5565 13.9813 21.2379 14.675C21.1073 14.9593 21.022 15.2353 21.0037 15.5C21.2781 15.502 21.5 15.7251 21.5 16C21.5 16.2761 21.2761 16.5 21 16.5V17.0625C21 17.3386 20.7761 17.5625 20.5 17.5625C20.2239 17.5625 20 17.3386 20 17.0625V16.5L19 16.5C18.7239 16.5 18.5 16.2761 18.5 16C18.5 15.7239 18.7239 15.5 19 15.5L20.0022 15.5C20.0213 15.0468 20.1607 14.6245 20.3292 14.2575C20.6019 13.6639 21 12.5343 21 11C21 8.77614 19.2239 7 17 7C15.5824 7 14.8792 7.3379 14.3089 7.61196L14.2634 7.63382C13.906 7.80583 13.5026 8 13 8C12.4974 8 12.094 7.80582 11.7366 7.63382L11.6911 7.61196C11.1208 7.3379 10.4176 7 9 7Z"
          className="fill-tempo-blue-120"
        />
        <path
          d="M6.5 16C6.5 15.7239 6.72386 15.5 7 15.5H9C9.27614 15.5 9.5 15.7239 9.5 16C9.5 16.2761 9.27614 16.5 9 16.5H7C6.72386 16.5 6.5 16.2761 6.5 16Z"
          className="fill-tempo-blue-120"
        />
        <path
          d="M11 15.5C10.7239 15.5 10.5 15.7239 10.5 16C10.5 16.2761 10.7239 16.5 11 16.5H13C13.2761 16.5 13.5 16.2761 13.5 16C13.5 15.7239 13.2761 15.5 13 15.5H11Z"
          className="fill-tempo-blue-120"
        />
        <path
          d="M14.5 16C14.5 15.7239 14.7239 15.5 15 15.5H17C17.2761 15.5 17.5 15.7239 17.5 16C17.5 16.2761 17.2761 16.5 17 16.5H15C14.7239 16.5 14.5 16.2761 14.5 16Z"
          className="fill-tempo-blue-120"
        />
        <path
          d="M23 15.5C22.7239 15.5 22.5 15.7239 22.5 16C22.5 16.2761 22.7239 16.5 23 16.5H25C25.2761 16.5 25.5 16.2761 25.5 16C25.5 15.7239 25.2761 15.5 25 15.5H23Z"
          className="fill-tempo-blue-120"
        />
        <path
          d="M5.5 18.6875C5.77614 18.6875 6 18.9114 6 19.1875V21.3125C6 21.5886 5.77614 21.8125 5.5 21.8125C5.22386 21.8125 5 21.5886 5 21.3125V19.1875C5 18.9114 5.22386 18.6875 5.5 18.6875Z"
          className="fill-tempo-blue-120"
        />
        <path
          d="M21 19.1875C21 18.9114 20.7761 18.6875 20.5 18.6875C20.2239 18.6875 20 18.9114 20 19.1875V21.3125C20 21.5886 20.2239 21.8125 20.5 21.8125C20.7761 21.8125 21 21.5886 21 21.3125V19.1875Z"
          className="fill-tempo-blue-120"
        />
        <path
          d="M5.5 22.9375C5.77614 22.9375 6 23.1614 6 23.4375V24.5C6 24.7761 6.22386 25 6.5 25H7.58333C7.85948 25 8.08333 25.2239 8.08333 25.5C8.08333 25.7761 7.85948 26 7.58333 26H6.5C5.67157 26 5 25.3284 5 24.5V23.4375C5 23.1614 5.22386 22.9375 5.5 22.9375Z"
          className="fill-tempo-blue-120"
        />
        <path
          d="M21 23.4375C21 23.1614 20.7761 22.9375 20.5 22.9375C20.2239 22.9375 20 23.1614 20 23.4375V24.5C20 24.7761 19.7761 25 19.5 25H18.4167C18.1405 25 17.9167 25.2239 17.9167 25.5C17.9167 25.7761 18.1405 26 18.4167 26H21.875C22.1511 26 22.375 25.7761 22.375 25.5C22.375 25.2239 22.1511 25 21.875 25H20.9146C20.9699 24.8436 21 24.6753 21 24.5V23.4375Z"
          className="fill-tempo-blue-120"
        />
        <path
          d="M9.25 25.5C9.25 25.2239 9.47386 25 9.75 25H11.9167C12.1928 25 12.4167 25.2239 12.4167 25.5C12.4167 25.7761 12.1928 26 11.9167 26H9.75C9.47386 26 9.25 25.7761 9.25 25.5Z"
          className="fill-tempo-blue-120"
        />
        <path
          d="M14.0833 25C13.8072 25 13.5833 25.2239 13.5833 25.5C13.5833 25.7761 13.8072 26 14.0833 26H16.25C16.5261 26 16.75 25.7761 16.75 25.5C16.75 25.2239 16.5261 25 16.25 25H14.0833Z"
          className="fill-tempo-blue-120"
        />
        <path
          d="M27 19.1875C27 18.9114 26.7761 18.6875 26.5 18.6875C26.2239 18.6875 26 18.9114 26 19.1875V21.3125C26 21.5886 26.2239 21.8125 26.5 21.8125C26.7761 21.8125 27 21.5886 27 21.3125V19.1875Z"
          className="fill-tempo-blue-120"
        />
        <path
          d="M26.5 22.9375C26.7761 22.9375 27 23.1614 27 23.4375V24.5C27 25.3284 26.3284 26 25.5 26H24.2917C24.0155 26 23.7917 25.7761 23.7917 25.5C23.7917 25.2239 24.0155 25 24.2917 25H25.5C25.7761 25 26 24.7761 26 24.5V23.4375C26 23.1614 26.2239 22.9375 26.5 22.9375Z"
          className="fill-tempo-blue-120"
        />
      </svg>
    );
  } else {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classNames('', className)}
        role="presentation"
        pointerEvents="none"
      >
        <title>Carb Conscious</title>
        <path
          d="M17.5 6.52699V6.5H23C25.5 6.5 27.5 8.5 27.5 11C27.5 12.7449 27.0129 14.0026 26.7186 14.6032C26.5883 14.8691 26.5 15.158 26.5 15.4542V16H20.5V15.6056C20.5 15.2107 20.6187 14.8251 20.7836 14.4662C21.0792 13.8226 21.5 12.6217 21.5 11C21.5 8.66911 19.7614 6.77286 17.5 6.52699Z"
          fill="transparent"
        />
        <path
          d="M9 7C6.77614 7 5 8.77614 5 11C5 12.5343 5.39809 13.6639 5.6708 14.2575C5.85236 14.6528 6 15.1124 6 15.6056V17.0625C6 17.3386 5.77614 17.5625 5.5 17.5625C5.22386 17.5625 5 17.3386 5 17.0625L5 16.5H4C3.72386 16.5 3.5 16.2761 3.5 16C3.5 15.7239 3.72386 15.5 4 15.5H4.9963C4.978 15.2353 4.89269 14.9593 4.76208 14.675C4.44347 13.9813 4 12.709 4 11C4 8.22386 6.22386 6 9 6C10.6371 6 11.4959 6.4087 12.134 6.71534C12.5333 6.90716 12.7445 7 13 7C13.2555 7 13.4667 6.90716 13.866 6.71534C14.5041 6.4087 15.3629 6 17 6C17.3453 6 17.6821 6.03441 18.0071 6.1H23C25.7209 6.1 27.9 8.27909 27.9 11C27.9 12.6916 27.4611 13.9496 27.147 14.6332C27.0109 14.9296 26.9199 15.2234 26.9029 15.5094C26.9343 15.5032 26.9668 15.5 27 15.5H28C28.2761 15.5 28.5 15.7239 28.5 16C28.5 16.2761 28.2761 16.5 28 16.5H27V17.0625C27 17.3386 26.7761 17.5625 26.5 17.5625C26.2239 17.5625 26 17.3386 26 17.0625V16C26 15.8874 26.0372 15.7835 26.1 15.7V15.6056C26.1 15.1321 26.2419 14.6873 26.4201 14.2993C26.6974 13.6956 27.1 12.5518 27.1 11C27.1 8.72091 25.2791 6.9 23 6.9H19.8748C21.1629 7.80143 22 9.29677 22 11C22 12.709 21.5565 13.9813 21.2379 14.675C21.1073 14.9593 21.022 15.2353 21.0037 15.5C21.2781 15.502 21.5 15.7251 21.5 16C21.5 16.2761 21.2761 16.5 21 16.5V17.0625C21 17.3386 20.7761 17.5625 20.5 17.5625C20.2239 17.5625 20 17.3386 20 17.0625V16.5L19 16.5C18.7239 16.5 18.5 16.2761 18.5 16C18.5 15.7239 18.7239 15.5 19 15.5L20.0022 15.5C20.0213 15.0468 20.1607 14.6245 20.3292 14.2575C20.6019 13.6639 21 12.5343 21 11C21 8.77614 19.2239 7 17 7C15.5824 7 14.8792 7.3379 14.3089 7.61196L14.2634 7.63382C13.906 7.80583 13.5026 8 13 8C12.4974 8 12.094 7.80582 11.7366 7.63382L11.6911 7.61196C11.1208 7.3379 10.4176 7 9 7Z"
          fill="#4A4A4A"
        />
        <path
          d="M6.5 16C6.5 15.7239 6.72386 15.5 7 15.5H9C9.27614 15.5 9.5 15.7239 9.5 16C9.5 16.2761 9.27614 16.5 9 16.5H7C6.72386 16.5 6.5 16.2761 6.5 16Z"
          fill="#4A4A4A"
        />
        <path
          d="M11 15.5C10.7239 15.5 10.5 15.7239 10.5 16C10.5 16.2761 10.7239 16.5 11 16.5H13C13.2761 16.5 13.5 16.2761 13.5 16C13.5 15.7239 13.2761 15.5 13 15.5H11Z"
          fill="#4A4A4A"
        />
        <path
          d="M14.5 16C14.5 15.7239 14.7239 15.5 15 15.5H17C17.2761 15.5 17.5 15.7239 17.5 16C17.5 16.2761 17.2761 16.5 17 16.5H15C14.7239 16.5 14.5 16.2761 14.5 16Z"
          fill="#4A4A4A"
        />
        <path
          d="M23 15.5C22.7239 15.5 22.5 15.7239 22.5 16C22.5 16.2761 22.7239 16.5 23 16.5H25C25.2761 16.5 25.5 16.2761 25.5 16C25.5 15.7239 25.2761 15.5 25 15.5H23Z"
          fill="#4A4A4A"
        />
        <path
          d="M5.5 18.6875C5.77614 18.6875 6 18.9114 6 19.1875V21.3125C6 21.5886 5.77614 21.8125 5.5 21.8125C5.22386 21.8125 5 21.5886 5 21.3125V19.1875C5 18.9114 5.22386 18.6875 5.5 18.6875Z"
          fill="#4A4A4A"
        />
        <path
          d="M21 19.1875C21 18.9114 20.7761 18.6875 20.5 18.6875C20.2239 18.6875 20 18.9114 20 19.1875V21.3125C20 21.5886 20.2239 21.8125 20.5 21.8125C20.7761 21.8125 21 21.5886 21 21.3125V19.1875Z"
          fill="#4A4A4A"
        />
        <path
          d="M5.5 22.9375C5.77614 22.9375 6 23.1614 6 23.4375V24.5C6 24.7761 6.22386 25 6.5 25H7.58333C7.85948 25 8.08333 25.2239 8.08333 25.5C8.08333 25.7761 7.85948 26 7.58333 26H6.5C5.67157 26 5 25.3284 5 24.5V23.4375C5 23.1614 5.22386 22.9375 5.5 22.9375Z"
          fill="#4A4A4A"
        />
        <path
          d="M21 23.4375C21 23.1614 20.7761 22.9375 20.5 22.9375C20.2239 22.9375 20 23.1614 20 23.4375V24.5C20 24.7761 19.7761 25 19.5 25H18.4167C18.1405 25 17.9167 25.2239 17.9167 25.5C17.9167 25.7761 18.1405 26 18.4167 26H21.875C22.1511 26 22.375 25.7761 22.375 25.5C22.375 25.2239 22.1511 25 21.875 25H20.9146C20.9699 24.8436 21 24.6753 21 24.5V23.4375Z"
          fill="#4A4A4A"
        />
        <path
          d="M9.25 25.5C9.25 25.2239 9.47386 25 9.75 25H11.9167C12.1928 25 12.4167 25.2239 12.4167 25.5C12.4167 25.7761 12.1928 26 11.9167 26H9.75C9.47386 26 9.25 25.7761 9.25 25.5Z"
          fill="#4A4A4A"
        />
        <path
          d="M14.0833 25C13.8072 25 13.5833 25.2239 13.5833 25.5C13.5833 25.7761 13.8072 26 14.0833 26H16.25C16.5261 26 16.75 25.7761 16.75 25.5C16.75 25.2239 16.5261 25 16.25 25H14.0833Z"
          fill="#4A4A4A"
        />
        <path
          d="M27 19.1875C27 18.9114 26.7761 18.6875 26.5 18.6875C26.2239 18.6875 26 18.9114 26 19.1875V21.3125C26 21.5886 26.2239 21.8125 26.5 21.8125C26.7761 21.8125 27 21.5886 27 21.3125V19.1875Z"
          fill="#4A4A4A"
        />
        <path
          d="M26.5 22.9375C26.7761 22.9375 27 23.1614 27 23.4375V24.5C27 25.3284 26.3284 26 25.5 26H24.2917C24.0155 26 23.7917 25.7761 23.7917 25.5C23.7917 25.2239 24.0155 25 24.2917 25H25.5C25.7761 25 26 24.7761 26 24.5V23.4375C26 23.1614 26.2239 22.9375 26.5 22.9375Z"
          fill="#4A4A4A"
        />
      </svg>
    );
  }
};

CarbConsciousIcon.propTypes = {
  className: PropTypes.string,
  hcSelected: PropTypes.bool,
  tempoSelected: PropTypes.bool,
};

export default CarbConsciousIcon;
